import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { BankLogoSize } from './types/bankLogoSize'

interface SizeProps {
  size: BankLogoSize
}

const sizeMap = {
  small: '28px',
  medium: '48px',
}

export const ImageContainer = styled.div<SizeProps>`
  display: flex;
  justify-content: center;
  width: ${({ size }) => sizeMap[size]};
  height: ${({ size }) => sizeMap[size]};
  border-radius: ${BorderRadius.R6};

  img {
    display: block;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
`

export const BlankImageContainer = styled.div<SizeProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ size }) => sizeMap[size]};
  height: ${({ size }) => sizeMap[size]};
  padding: ${Spacing.S8};
  border-radius: ${({ size }) => (size === 'small' ? BorderRadius.R8 : BorderRadius.R12)};
  background-color: ${Color.Green100};
`
